var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReslogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 33,
    viewBox: "0 0 90 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.14832 7.14458L13.5229 14.6034V0.0133057L10.8173 1.56312V10.0046L6.38094 7.26708L8.93733 5.65069V2.64693L1.14832 7.14458Z",
    fill: "#F4E096"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5399 25.1565L15.2692 17.7456V32.2398L17.9507 30.6927V22.3445L22.3871 25.0793L19.8307 26.6957V29.6062L27.5399 25.1565Z",
    fill: "#F4E096"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3829 5.8371L17.8762 10.0498V4.73732L20.7335 6.44158L23.4896 4.74531L15.2692 0V14.6114L27.7769 7.22182L25.3829 5.8371Z",
    fill: "#F4E096"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50987 26.4587L10.9154 22.3045V27.6197L8.05812 25.9154L5.40054 27.5504L13.5224 32.2398V17.7456L1.11325 25.0766L3.50987 26.4587Z",
    fill: "#F4E096"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7941 9.03784V18.2196L26.235 16.7283V13.4157L23.3458 15.0454L21.4258 16.1265L26.235 18.9279L28.7941 20.4191V23.4362L18.7948 17.6098L16.2358 16.1185L17.8096 15.2318L18.8667 14.6353L20.784 13.5541L26.235 10.4811L28.7941 9.03784Z",
    fill: "#F4E096"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.4362V14.2545L2.55906 15.7457V19.0584L5.44832 17.4287L7.36828 16.3475L2.55906 13.5462L0 12.0549V9.03784L9.99923 14.8643L12.5583 16.3555L10.9845 17.2423L9.92734 17.8388L8.01004 18.9199L2.55906 21.9929L0 23.4362Z",
    fill: "#F4E096"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6944 9.37474H39.518V14.8928H44.4097V9.37474H47.2234V24H44.4097V17.5872H39.518V24H36.6944V9.37474ZM50.9812 9.37474H58.965V12.099H53.7452V14.7436H58.965V17.4181H53.7452V21.2658H58.965V24H50.9812V9.37474ZM60.8636 9.37474H63.6077L65.7155 18.7106L68.3303 9.37474H70.6469L73.2916 18.7106L75.3795 9.37474H78.1236L74.8326 24H72.1581L69.4637 14.5448L66.8191 24H64.1744L60.8636 9.37474ZM80.7281 9.37474H88.7118V12.099H83.4921V14.7436H88.7118V17.4181H83.4921V21.2658H88.7118V24H80.7281V9.37474Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReslogo);
export default __webpack_public_path__ + "static/media/reslogo.8b28e023aafa096234ef007e13333160.svg";
export { ForwardRef as ReactComponent };